import dayjs from '@/utilities/dayjs-config'

export const NEW_PROGRAM_CUTOFF_DAY = 3
export const NEW_PROGRAM_WEEK_CAP = 5

// TODO: move to another place probably
export const SUBSCRIPTION_CUTOFF_DAY = 3

// How many weeks into the future can you modify
export const MODIFIABLE_WEEK_CAP = 8
export const MODIFIABLE_MEAL_SWAP_WEEK_CAP = 4

// How many weeks into the future can you redeem
export const PACK_OF_WEEKS_REDEMPTION_WEEK_CAP = 5

export const MEAL_CHANGE_CUTOFF =
  dayjs().tz().day() <= SUBSCRIPTION_CUTOFF_DAY
    ? dayjs().tz().day(SUBSCRIPTION_CUTOFF_DAY).endOf('day')
    : dayjs()
        .tz()
        .day(SUBSCRIPTION_CUTOFF_DAY + 7)
        .endOf('day')
export const NEW_PROGRAM_CUTOFF =
  dayjs().tz().day() <= NEW_PROGRAM_CUTOFF_DAY
    ? dayjs().tz().day(NEW_PROGRAM_CUTOFF_DAY).endOf('day')
    : dayjs()
        .tz()
        .day(NEW_PROGRAM_CUTOFF_DAY + 7)
        .endOf('day')

export const EARLIEST_MODIFIABLE_WEEK = dayjs(MEAL_CHANGE_CUTOFF).day(8)
export const EARLIEST_NEW_PROGRAM_WEEK = dayjs(NEW_PROGRAM_CUTOFF).day(8)
export const LATEST_NEW_PROGRAM_WEEK = dayjs(EARLIEST_NEW_PROGRAM_WEEK)
  .add(NEW_PROGRAM_WEEK_CAP - 1, 'weeks')
  .startOf('week')
export const LATEST_MODIFIABLE_WEEK = dayjs()
  .add(MODIFIABLE_WEEK_CAP, 'weeks')
  .startOf('week')
export const LATEST_MODIFIABLE_MEAL_SWAP_WEEK = dayjs()
  .add(MODIFIABLE_MEAL_SWAP_WEEK_CAP, 'weeks')
  .startOf('week')

export const HOLIDAY_WEEK = '2024-11-25' // TODO: remove or refactor
